const myModalApp = angular.module('inspinia');

myModalApp.directive('baseModalFooter', function () {
  return {
    templateUrl: `/manage/src/view/directive/base_modal_footer.html?${new Date().getTime()}`,
    replace: true,
    restrict: 'E',
    transclude: true,
  };
});
